/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Node_QuoteInputs */

const en_fw_node_quote = /** @type {(inputs: Fw_Node_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“It was love at first sight, so marry me.” She says it to the man sent to kill her. He says yes.`)
};

const zh_fw_node_quote = /** @type {(inputs: Fw_Node_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“我对你一见钟情，请娶我吧。”她对奉命来杀她的男人这样说，而他答应了。`)
};

/**
* | output |
* | --- |
* | "“It was love at first sight, so marry me.” She says it to the man sent to kill her. He says yes." |
*
* @param {Fw_Node_QuoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_node_quote = /** @type {((inputs?: Fw_Node_QuoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Node_QuoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_node_quote(inputs)
	return zh_fw_node_quote(inputs)
});
export { fw_node_quote as "fw.node.quote" }